module.exports = __webpack_public_path__ + "static/media/GT-America-Extended-Bold.ebbc4701.otf";